// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FranchisorChannels_BindingRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * FranchisorChannels_BindingRow — one row of `franchisor_channel_triggers`
 * (a trigger x channel binding) for the Full-only console matrix.
 *
 * `channel_type` is DENORMALIZED by the controller (joined in from the
 * channel row) so the matrix UI can show "email" / "sms" without a second
 * round trip per binding.
 */
import { registerContract } from './validate'

export interface FranchisorChannels_BindingRow {
id: number
channel_id: number
template_id: number
trigger_key?: string
channel_type?: string
recipient_groups?: string[]
enabled?: boolean
created_at?: string
updated_at?: string
}

registerContract('FranchisorChannels_BindingRow', {
  id:               { type: 'number',  required: true },
  channel_id:       { type: 'number',  required: true },
  template_id:      { type: 'number',  required: true },
  trigger_key:      { type: 'string',  required: false },
  channel_type:     { type: 'string',  required: false },
  recipient_groups: { type: 'array',   required: false },
  enabled:          { type: 'boolean', required: false },
  created_at:       { type: 'string',  required: false },
  updated_at:       { type: 'string',  required: false },
})
